export * from "./printable-template.component";
